export const standardError = {
	header: 'Oops! Something Went Wrong',
	label: 'An error occurred. Please reload the page to try again.',
	appearance: 'danger',
};

export const standardSuccess = {
	header: 'Data saved successfully!',
	label: 'Your changes have been updated.',
	appearance: 'success',
};

export const standardDeletedSuccess = {
	header: 'Data deleted successfully!',
	label: 'Your changes have been updated.',
	appearance: 'success',
};

export const copySuccess = {
	header: 'Data copied successfully!',
	label: 'UUID has been copied.',
	appearance: 'success',
};
